export const DELETE_CONFIRAMATION = 'Are you sure, do you want to delete?';
export const SURVEY_APPROVED_QUESTION_CONFIRAMATION = 'Some of the modules included in the survey have unapproved questions. Such questions will not be visible in the published Survey unless they are approved. Are you sure you want to proceed with publishing the survey?';
export const SUBMIT_CONFIRAMATION = 'Are you sure, do you want to submit?';
export const OFFLINE_DEACTIVATION_CONFIRAMATION = 'You are deactivating offline mode, this will leads to data loss(offline collected). Are you sure, you want to deactivate offline mode?';
export const LOGOUT_WARNING_IN_OFFLINE_MODE_CONFIRAMATION = "You won't be able to login again, if there is no internet connectivity. Are you sure, you want to logout?";
export const DELETE_YES_BUTTTON_TEXT = 'Yes';
export const DELETE_NO_BUTTTON_TEXT = 'No';
export const APPROVED_QUESTION_CONFIRAMATION = 'Are you sure you want to approve this question?';
export const REJECT_QUESTION_CONFIRAMATION = 'Are you sure you want to reject this question?';
export const ASSIGN_CREATOR_QUESTION_CONFIRAMATION = 'Are you sure you want to assign this question back to the Regional Admin?';
export const PAGE_DELETE_CONFIRAMATION = 'Are you sure you want to delete this page?';
export const CLUSTER_DELETE_CONFIRAMATION = 'Are you sure you want to delete this cluster?';
// Message Constants
export const TOSTAR_POSITION = 'top-center';
export const TOSTAR_DURATION = 4000;

export const SURVEY = 'Survey';
export const USER = 'User';
export const MODULE = 'Module';
export const QUESTION = 'Question';
export const RESPONSE = 'Response';
export const REMINDER = 'Reminder';
export const ACTIVE_COUNTRY = 'Active Country';
export const OFFLINE_RESPONSE = 'Offline Response';

export const MESSAGE_FOR_SAVED = ' saved successfully';
export const MESSAGE_FOR_SUBMITTED = ' submitted successfully';
export const MESSAGE_FOR_CREATED = ' created successfully';
export const MESSAGE_FOR_DELETED = ' deleted successfully';
export const MESSAGE_FOR_UPDATED = ' updated successfully';
export const MESSAGE_FOR_APPROVED = ' approved successfully';
export const MESSAGE_FOR_REJECTED = ' rejected successfully';
export const MESSAGE_FOR_PUBLISHED = ' published successfully';
export const MESSAGE_FOR_REGISTERED = ' registered successfully';
export const MESSAGE_FOR_PUBLISH_ERROR = 'You can only publish survey for current year';
export const MESSAGE_FOR_QUESTION_DELETE = 'Do you want to delete question from the module?';
export const INVALID_RESPNSE_OBJECT = 'Invalid response object';
export const MESSAGE_FOR_FORGOT_PASSWORD = 'Reset password link sent successfully on registered email id.';
export const RESET_PASSWORD_SUCCESS = ' Password successfully reset. Try login now.';
export const NO_INTERNET_CONNECTIVITY = 'No Internet Connectivity';


export const REGION_EMPTY_ERROR = 'Please select the region.';
export const ASSIGN_COUNTRY_ERROR = 'Please assign at least one country';
export const MODULE_EMPTY_ERROR = 'Please select the module.';
export const VERIFY_CAPTCHA_MESSAGE = 'reCAPTCHA should be verified.';
export const INVALID_REGION_ERROR = 'You cannot assign more than one Region.';
export const SHARE_LINK_MESSAGE = 'Link shared successfully';
export const APPROVED_MESSAGE = 'Question approved successfully';
export const REJECT_MESSAGE = 'Question rejected successfully';
export const ASSIGN_CREATOR_MESSAGE = 'Question assigned back to creator';


// WEBPACK FOOTER //
// ./src/constants/NotificationMessageConstant.tsx